import DatePicker, { registerLocale } from 'react-datepicker';
import { ja } from 'date-fns/locale';
import CalendarInput from './CalendarInput';
import { useState } from 'react';
import { format } from 'date-fns';
import '../../styles/picker.css';

registerLocale('ja', ja);

interface YearPickerProps {
  // 選択された年
  selectedYear: Date | null;
  // 年が選択されたときのコールバック
  onYearChange: (year: Date | null) => void;
}
const YearPicker = ({ selectedYear, onYearChange }: YearPickerProps) => {
  const [open, setOpen] = useState(false);
  return (
    <DatePicker
      calendarClassName="year-picker"
      selected={selectedYear ? selectedYear : null}
      open={open}
      onClickOutside={() => setOpen(false)}
      onInputClick={() => setOpen(true)}
      onChange={(d: Date | null) => onYearChange(d)}
      showYearPicker
      dateFormat="yyyy"
      locale="ja"
      placeholderText="4桁の西暦"
      customInput={
        <CalendarInput
          value={selectedYear ? format(selectedYear, 'yyyy') : ''}
          placeholder="4桁の西暦"
          onClick={() => setOpen(true)}
          className="year-picker-input"
        />
      }
    />
  );
};

export default YearPicker;
